module.exports = __webpack_public_path__ + "media/offers_icons/motocykle-white-91bc97fa.svg";